import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import BuildEnvBanner from './components/BuildEnvBanner'
import Layout from './components/Layout'
import Landing from './pages/Landing'
import AccountCreate from './pages/account/AccountCreate'
import Login from './pages/auth/Login'
import ChangePassword from './pages/auth/ChangePassword'
import Main from './pages/main/Main'
import UserList from './pages/user/UserList'
import UserCreate from './pages/user/UserCreate'
import UserUpdate from './pages/user/UserUpdate'
import ProjectMain from './pages/project/ProjectMain'
import ProjectCreate from './pages/project/ProjectCreate'
import ProjectUpdate from './pages/project/ProjectUpdate'
import ProjectLayout from './pages/project/ProjectLayout'
import ProjectDashboard from './pages/project/ProjectDashboard'
import BrandConfig from './pages/project/BrandConfig'
import ProjectConfig from './pages/project/ProjectConfig'
import BrandUpdate from './pages/project/BrandUpdate'
import AppList from './pages/project/AppList'
import AppCreate from './pages/project/AppCreate'
import AppUpdate from './pages/project/AppUpdate'
import AppConfig from './pages/project/AppConfig'
import NotificationChannelList from './pages/project/NotificationChannelList'
import NotificationChannelCreate from './pages/project/NotificationChannelCreate'
import NotificationChannelUpdate from './pages/project/NotificationChannelUpdate'
import BoardList from './pages/board/BoardList'
import BoardCreate from './pages/board/BoardCreate'
import BoardUpdate from './pages/board/BoardUpdate'
import BoardCategoryConfig from './pages/board/BoardCategoryConfig'
import BrandList from './pages/shop/BrandList'
import ShopGroupList from './pages/shop/ShopGroupList'
import ShopList from './pages/shop/ShopList'
import ShopCreate from './pages/shop/ShopCreate'
import ShopUpdate from './pages/shop/ShopUpdate'
import ShopCategoryGroupList from './pages/shop/ShopCategoryGroupList'
import ShopCategoryGroupCreate from './pages/shop/ShopCategoryGroupCreate'
import ShopCategoryGroupUpdate from './pages/shop/ShopCategoryGroupUpdate'
import ShopCategoryGroupTreeConfig from './pages/shop/ShopCategoryGroupTreeConfig'
import ShopCategoryGroupShopConfig from './pages/shop/ShopCategoryGroupShopConfig'
import ProductList from './pages/product/ProductList'
import ProductCreate from './pages/product/ProductCreate'
import ProductUpdate from './pages/product/ProductUpdate'
import CategoryGroupList from './pages/product/CategoryGroupList'
import CategoryGroupCreate from './pages/product/CategoryGroupCreate'
import CategoryGroupUpdate from './pages/product/CategoryGroupUpdate'
import CategoryGroupTreeConfig from './pages/product/CategoryGroupTreeConfig'
import CategoryGroupProductConfig from './pages/product/CategoryGroupProductConfig'
import ProductOptionGroupList from './pages/product/ProductOptionGroupList'
import ProductOptionGroupCreate from './pages/product/ProductOptionGroupCreate'
import ProductOptionGroupUpdate from './pages/product/ProductOptionGroupUpdate'
import ProductOptionGroupConfig from './pages/product/ProductOptionGroupConfig'
import VoucherList from './pages/voucher/VoucherList'
import VoucherCreate from './pages/voucher/VoucherCreate'
import VoucherUpdate from './pages/voucher/VoucherUpdate'
import VoucherCategoryGroupList from './pages/voucher/CategoryGroupList'
import VoucherCategoryGroupCreate from './pages/voucher/CategoryGroupCreate'
import VoucherCategoryGroupUpdate from './pages/voucher/CategoryGroupUpdate'
import VoucherCategoryGroupTreeConfig from './pages/voucher/CategoryGroupTreeConfig'
import VoucherCategoryGroupProductConfig from './pages/voucher/CategoryGroupVoucherConfig'
import MembershipDashboard from './pages/membership/MembershipDashboard'
import MembershipDashboard_old from './pages/membership/MembershipDashboard_old'
import MembershipCreate from './pages/membership/MembershipCreate'
import MembershipUpdate from './pages/membership/MembershipUpdate'
import MembershipList from './pages/membership/MembershipList'
import PinSendList from './pages/customer/PinSendList'
import PostList from './pages/board/PostList'
import PostCreate from './pages/board/PostCreate'
import PostView from './pages/board/PostView'
import PostUpdate from './pages/board/PostUpdate'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Settings from './pages/Settings'

function App() {
  return (
    <>
      <BuildEnvBanner />
      <Routes>
      {/* Landing 페이지는 레이아웃 없이 전체 화면 */}
      <Route path="/" element={<Landing />} />
      
      {/* 계정 생성 (REST: accounts 컬렉션) */}
      <Route path="/accounts/create" element={<AccountCreate />} />
      
      {/* 로그인 페이지 */}
      <Route path="/auth/login" element={<Login />} />
      {/* 비밀번호 변경 페이지 */}
      <Route path="/auth/change-password" element={<ChangePassword />} />
      
      {/* 메인 페이지 */}
      <Route path="/main" element={<Main />} />
      
      {/* 사용자 */}
      <Route path="/users" element={<UserList />} />
      <Route path="/users/create" element={<UserCreate />} />
      <Route path="/users/:userId/update" element={<UserUpdate />} />
      
      {/* 프로젝트 */}
      <Route path="/projects" element={<ProjectMain />} />
      <Route path="/projects/create" element={<ProjectCreate />} />
      <Route path="/projects/:projectCode" element={<ProjectLayout />}>
        <Route path="dashboard" element={<ProjectDashboard />} />
        <Route path="config" element={<ProjectConfig />} />
        <Route path="update" element={<ProjectUpdate />} />
        <Route path="notification-channel-settings/create" element={<NotificationChannelCreate />} />
        <Route path="notification-channel-settings/:channel/update" element={<NotificationChannelUpdate />} />
        <Route path="notification-channel-settings" element={<NotificationChannelList />} />
        <Route path="apps" element={<AppList />} />
        <Route path="apps/create" element={<AppCreate />} />
        <Route path="apps/:appCode/config" element={<AppConfig />} />
        <Route path="apps/:appCode/update" element={<AppUpdate />} />
        <Route path="brands" element={<BrandConfig />} />
        <Route path="brands/:brandCode/update" element={<BrandUpdate />} />
        <Route path="boards/create" element={<BoardCreate />} />
        <Route path="boards/:boardCode/update" element={<BoardUpdate />} />
        <Route path="boards/:boardCode/categories" element={<BoardCategoryConfig />} />
        <Route path="boards" element={<BoardList />} />
        <Route path="posts/:boardCode/create" element={<PostCreate />} />
        <Route path="posts/:boardCode/:postCode/edit" element={<PostUpdate />} />
        <Route path="posts/:boardCode/:postCode" element={<PostView />} />
        <Route path="posts/:boardCode" element={<PostList />} />
        <Route path="posts" element={<PostList />} />
      </Route>
      
      {/* 매장 도메인 */}
      <Route path="/shops/brands" element={<BrandList />} />
      <Route path="/shops/groups" element={<ShopGroupList />} />
      <Route path="/shops/category-groups" element={<ShopCategoryGroupList />} />
      <Route path="/shops/category-groups/create" element={<ShopCategoryGroupCreate />} />
      <Route path="/shops/category-groups/:categoryGroupCode/update" element={<ShopCategoryGroupUpdate />} />
      <Route path="/shops/category-groups/:categoryGroupCode/tree" element={<ShopCategoryGroupTreeConfig />} />
      <Route path="/shops/category-groups/:categoryGroupCode/shops" element={<ShopCategoryGroupShopConfig />} />
      <Route path="/shops" element={<ShopList />} />
      <Route path="/shops/create" element={<ShopCreate />} />
      <Route path="/shops/:shopCode/update" element={<ShopUpdate />} />
      
      {/* 상품 도메인 (정적 세그먼트를 :productCode 보다 위에 둠) */}
      <Route path="/products" element={<ProductList />} />
      <Route path="/products/create" element={<ProductCreate />} />
      <Route path="/products/category-groups" element={<CategoryGroupList />} />
      <Route path="/products/category-groups/create" element={<CategoryGroupCreate />} />
      <Route path="/products/category-groups/:categoryGroupCode/update" element={<CategoryGroupUpdate />} />
      <Route path="/products/category-groups/:categoryGroupCode/tree" element={<CategoryGroupTreeConfig />} />
      <Route path="/products/category-groups/:categoryGroupCode/products" element={<CategoryGroupProductConfig />} />
      <Route path="/products/option-groups" element={<ProductOptionGroupList />} />
      <Route path="/products/option-groups/create" element={<ProductOptionGroupCreate />} />
      <Route path="/products/option-groups/:groupCode/update" element={<ProductOptionGroupUpdate />} />
      <Route path="/products/:productCode/option-groups" element={<ProductOptionGroupConfig />} />
      <Route path="/products/:productCode/update" element={<ProductUpdate />} />
      
      {/* 교환권 */}
      <Route path="/vouchers" element={<VoucherList />} />
      <Route path="/vouchers/create" element={<VoucherCreate />} />
      <Route path="/vouchers/:voucherCode/update" element={<VoucherUpdate />} />
      <Route path="/vouchers/category-groups" element={<VoucherCategoryGroupList />} />
      <Route path="/vouchers/category-groups/create" element={<VoucherCategoryGroupCreate />} />
      <Route path="/vouchers/category-groups/:categoryGroupCode/update" element={<VoucherCategoryGroupUpdate />} />
      <Route path="/vouchers/category-groups/:categoryGroupCode/tree" element={<VoucherCategoryGroupTreeConfig />} />
      <Route path="/vouchers/category-groups/:categoryGroupCode/vouchers" element={<VoucherCategoryGroupProductConfig />} />
      
      {/* 멤버십 */}
      <Route path="/memberships" element={<MembershipList />} />
      <Route path="/memberships/:membershipCode/dashboard" element={<MembershipDashboard />} />
      <Route path="/memberships/create" element={<MembershipCreate />} />
      <Route path="/memberships/:membershipCode/update" element={<MembershipUpdate />} />
      <Route path="/membership_old" element={<MembershipDashboard_old />} />
      <Route path="/customers/pin-sends" element={<PinSendList />} />

      {/* 콘솔 페이지들은 레이아웃과 함께 */}
      <Route path="/console" element={<Layout><Dashboard /></Layout>} />
      <Route path="/console/users" element={<Layout><Users /></Layout>} />
      <Route path="/console/settings" element={<Layout><Settings /></Layout>} />

      {/* 잘못된 경로일 때 Landing 페이지로 리다이렉트 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}

export default App
